import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../constants';
import { OauthAEMConfig } from '../../../models';
import { ContinueAuthentication } from '../../../models/multi-factor-authentication.interfaces';
import { UtilService } from '../../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class ContinueAuthenticationService {
  continueAuthenticationHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.continueAuthentication+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: UtilService
  ) {}

  continueAuthentication = (
    authConfig: OauthAEMConfig,
    flowIdValue: string
  ): Observable<ContinueAuthentication> => {
    const getContinueAuthenticationUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const continueAuthenticationUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getContinueAuthenticationUrl
      }
    ];

    return new ApiBuilder<undefined, ContinueAuthentication>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(continueAuthenticationUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .httpHeaders(this.continueAuthenticationHeader)
      .errorHandler(this._errorHandler)
      .library('CONTINUE_AUTHENTICATION_SERVICE')
      .withCredentials(true)
      .create();
  };
}
